/**
 * Loads Google Analytics 4 when REACT_APP_GA_MEASUREMENT_ID is set (production).
 */
export function initAnalytics() {
  const id = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();
  if (!id || process.env.NODE_ENV !== 'production') return;

  if (document.querySelector(`script[data-qnaread-ga="${id}"]`)) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  gtagScript.dataset.qnareadGa = id;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id, { anonymize_ip: true });
}
